import { Collection, Status, StatusChange, User } from ".";

export class statusChangeCollection{
    id?: number;
    statusChange? : StatusChange;
    collection: Collection;
    status: Status = new Status();
    createdAt: Date;
    createdUser: User;
    updatedAt: Date;
    updatedUser: User;
}
